import React, { useContext } from 'react';
import { Navbar } from 'flowbite-react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'flowbite-react/lib/esm/components/Dropdown';
import { GlobalContext } from '../../context/GlobalContext';
import logo from '../../logo.png';
import avatar from '../../img/avatar.svg';
import Cookies from 'js-cookie';

function LandingNavbar(props) {
    const { handlers, state } = useContext(GlobalContext);
    const { userData } = state;
    const { handleLogout } = handlers;

    return (
        <div className='sticky top-2 z-10 mt-2 bg-slate-100 md:px-10 md:pt-1'>
            <Navbar fluid={true} rounded={true}>
                <Link to='/'>
                    <div className='flex'>
                        <img
                            src={logo}
                            className='mr-3 h-6 sm:h-9'
                            alt='Logo'
                        />
                        <span className='self-center whitespace-nowrap text-xl font-[800] dark:text-white'>
                            S<span className='text-sky-600'>ee</span>kr
                        </span>
                    </div>
                </Link>

                <div className='flex md:order-2'>
                    {!Cookies.get('token') && (
                        <Link to={'/login'}>
                            <button
                                type='button'
                                className={`flex ${
                                    props.Login && 'opacity-0'
                                } p-auto items-center gap-x-3 rounded-lg bg-sky-500 px-5 py-2.5 text-sm font-medium text-white hover:bg-sky-600 focus:outline-none focus:ring-4 focus:ring-sky-300`}
                                disabled={props.Login ? true : false}
                            >
                                <svg
                                    className='h-6 w-6'
                                    fill='none'
                                    stroke='currentColor'
                                    viewBox='0 0 24 24'
                                    xmlns='http://www.w3.org/2000/svg'
                                >
                                    <path
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                        strokeWidth={2}
                                        d='M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1'
                                    />
                                </svg>
                                <p className='hidden md:block'>Login</p>
                            </button>
                        </Link>
                    )}
                    {Cookies.get('token') && (
                        <div className='flex items-center gap-x-2'>
                            <Dropdown
                                label={
                                    userData !== null && (
                                        <div className='relative'>
                                            <img
                                                alt='profil'
                                                src={
                                                    userData.image_url.length <
                                                    10
                                                        ? avatar
                                                        : userData.image_url
                                                }
                                                className='mx-auto h-8 w-8 rounded-full object-cover '
                                            />
                                        </div>
                                    )
                                }
                                color={''}
                            >
                                <Dropdown.Item>
                                    <Link to={'/dashboard'}>Dashboard</Link>
                                </Dropdown.Item>
                                <Dropdown.Item>
                                    <button onClick={handleLogout}>
                                        Logout
                                    </button>
                                </Dropdown.Item>
                            </Dropdown>
                        </div>
                    )}
                    <Navbar.Toggle />
                </div>
                <Navbar.Collapse>
                    <Link to={'/'}>
                        <p className='hover:text-sky-500'>Home</p>
                    </Link>
                    <Link to={'/'}>
                        <p className='hover:text-sky-500'>About Us</p>
                    </Link>
                    <Link to={'/'}>
                        <p className='hover:text-sky-500'>CV Review</p>
                    </Link>
                </Navbar.Collapse>
            </Navbar>
        </div>
    );
}

export default LandingNavbar;
